import DefaultTermsAndConditions from "../../../modules/hints/components/DefaultTermsAndConditions";
import { HintsLink } from "../../../modules/hints/components/HintsLink";
import Config from "../config";

const TermsAndConditions = ({ lang }: { lang: string }) => {
  return (
    <DefaultTermsAndConditions
      lang={lang}
      companyName="kolula solutions UG (haftungsbeschränkt)"
      domain="badesee-petershagen.kolula.com"
      email="support@kolula.com"
      tenantServiceName="kolula SUP"
      address={
        <>
          <br />
          kolula solutions UG (haftungsbeschränkt)
          <br />
          c/o SchneiderGolling & Cie. AG
          <br />
          Niederkasseler Lohweg 18
          <br />
          40547 Düsseldorf
          <br />
          <br />
          Telefonnummer:{" "}
          <HintsLink href={`tel:${Config.contact.phone}`}>{Config.contact.phone}</HintsLink>
          <br />
          E-Mail:{" "}
          <HintsLink href="mailto:support@kolula.com">
            support@kolula.com
          </HintsLink>
          <br />
          Website:{" "}
          <HintsLink
            href="https://kolula-sup.com"
            rel="noopener"
            target="_blank"
          >
            https://kolula-sup.com
          </HintsLink>
          <br />
          <br />
        </>
      }
    />
  );
};

export default TermsAndConditions;
